import React, { Fragment } from 'react';

// Components
import DownloadBtn_Win from '../common/DownloadBtn_Win';
import DownloadBtn_Apple from '../common/DownloadBtn_Apple';
  
const GettingStarted = ({
    isMobile
}) =>  {
	return (
        <Fragment>
              
            {/* Heading */}
            <div style={{paddingBottom: '2rem', marginBottom: '2rem', borderBottom: '1px solid rgb(39,39,42)'}}>
                <h1 style={{fontWeight: 'bold', fontSize: '1.5rem', margin: 0}}>
                    Getting Started
                </h1>
                <p style={{color: 'rgb(161,161,170)', fontSize: '.875rem', marginTop: '.5rem'}}>
                    Welcome to Interview Cheater. This guide will help you get up and running quickly.
                </p>
            </div>
            {/* Main content */}
            <div>
                {/* Box Section */}
                <div style={{padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
                    <h2 style={{color: 'rgb(228,228,231)', fontWeight: 500, fontSize: '1rem', margin: 0}}>
                    Quick Start Steps
                    </h2>
                    <ol style={{color: 'rgb(212,212,216)', fontSize: '.875rem', marginTop: '1rem', padding: '0', listStyle: 'none'}}>
                        <li>Install the Interview Cheater app in the download link below (MacOS only)</li>
                        <li style={{marginTop: '.75rem', lineHeight: '1.25rem'}}>Move the app into your Applications folder</li>
                        <li style={{marginTop: '.75rem', lineHeight: '1.25rem'}}>Sign up for an account or log in on the Interview Cheater website and subscribe.</li>
                        <li style={{marginTop: '.75rem', lineHeight: '1.25rem'}}>Open the app and log in with your account.</li>
                        <li style={{marginTop: '.75rem', lineHeight: '1.25rem'}}>Configure your language preferences (Python, Java, Javascript, Golang, C#, Rust, Ruby, C++, SQL, R, and Swift) in the <a href="#" style={{textDecoration: 'underline', color: 'inherit'}}>settings</a> page, or in the app.</li>
                        <li style={{marginTop: '.75rem', lineHeight: '1.25rem'}}>Take you first screenshot and start passing your tech interviews!</li>
                    </ol>
                    {/* Button */}
                    <div style={{marginTop: '1rem', display: 'grid', gridTemplateColumns:`${isMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'}`, gap: '1rem', width: '100%'}}>
                        {/* Download Buttons */}
                        <DownloadBtn_Apple fullWidth />
                        <DownloadBtn_Win fullWidth />
                    </div>
                </div>

                {/* Box Section */}
                {/* <div style={{marginTop: '2rem', padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
                    <h2 style={{color: 'rgb(228,228,231)', fontWeight: 500, fontSize: '1rem', margin: 0}}>
                    Getting Started Tutorial
                    </h2>
                    <div style={{width: '100%', aspectRatio: '16 / 9', marginTop: '1rem'}}>
                    <iframe style={{width: '100%', height: '100%', display: 'block', border: 'none'}} src="https://www.youtube.com/embed/w5LYB2u9-ho" />
                    </div>
                </div> */}
            </div>
        </Fragment>
	);
}
  
export default GettingStarted;
  